import { useMutation } from "@tanstack/react-query";
import { AxiosResponseAndError } from "../types/axiosResponseType";
import { requestURLs } from "../../Environment";
import ApiRequest from "../ApiRequest";

export const UseThradeDeleteMutation = () => {
  return useMutation<
    AxiosResponseAndError<null>["response"],
    AxiosResponseAndError<null>["error"],
    {thread_ID:string}
  >({
    mutationFn: ({thread_ID}) =>
        ApiRequest.delete(requestURLs.deleteThread+thread_ID),
  });
};
